import Axios from "axios";

const checkEmailURL = "https://pass.doublestruck.eu/checkmail.php";

const validEmail = async email => {
  const test = await Axios
    .get(checkEmailURL + "?email=" + email)
    .then(data => data);

  return test.data.message;
};

const getFieldError = async (field, formValues) => {
  let text = "";

  if (field.includes("Email")) {
    let emailMessage = validEmail(formValues[field]);
    text = await emailMessage;
  }
  return text;
};

export { validEmail, getFieldError };
